export default __webpack_public_path__ + "89162668be3461d35a4b86975a4f3a9c.png";